'use client'

import { CTAParameter } from 'airbridge-web-sdk-loader/build/airbridge_api/cta'
import { useTranslations } from 'next-intl'

import { useAirbridgeContext } from '@/shared/config'
import { Button } from '@/shared/ui'

import { PeriodTextButton } from './period-text-button'

type Props = {
  roomId: number
}

export const MobileContractActionArea = ({ roomId }: Props) => {
  const t = useTranslations('room_detail')

  const airbridge = useAirbridgeContext()

  const handleOpenDeeplink = (ctaParams: CTAParameter) => {
    airbridge.openDeeplink({
      deeplinks: {
        ios: `spacev33m2://app?type=room&idx=${roomId}`,
        android: `spacev33m2://app?type=room&idx=${roomId}`,
        desktop: `${window.location.origin}/guest/room/${roomId}`,
      },
      ctaParams,
    })
  }

  return (
    <div className="z-sheet fixed right-0 bottom-0 left-0 rounded-t-3xl bg-white/50 px-4 py-6 text-center shadow-[1px_-1px_4px_0_rgba(0,0,0,0.20)] backdrop-blur-sm">
      <PeriodTextButton
        onClick={() => {
          handleOpenDeeplink({
            cta_param_1: 'room_detail',
            cta_param_2: 'check_available_date',
            cta_param_3: '',
          })
        }}
      />
      <Button
        size="large"
        fullWidth
        className="mt-5"
        style={{
          background:
            'linear-gradient(90deg, rgba(78, 144, 249, 0.00) 0%, #4E90F9 100%), var(--Purple-purple-500, #895FFC)',
        }}
        onClick={() => {
          handleOpenDeeplink({
            cta_param_1: 'room_detail',
            cta_param_2: 'start_lease_in_app',
            cta_param_3: '',
          })
        }}
      >
        {t('button.start_contract_in_app')}
      </Button>
    </div>
  )
}
